import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import { ProveedorCatalogos } from './hooks/useCatalogos';
import { ProveedorGuias } from './hooks/useGuias';
import { ProveedorDialogo } from './components/ui/dialogo';
import { ProveedorAuth } from './hooks/useAuth';
import Resumen from './features/dashboard/Resumen';
import NuevaGuia from './features/guias/NuevaGuia';
import ListaGuias from './features/guias/ListaGuias';
import EstadoPago from './features/estadoPago/EstadoPago';
import Buscador from './features/analisis/Buscador';
import Jornada from './features/jornada/Jornada';
import Administracion from './features/admin/Administracion';
import './styles/index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Resumen /> },
      { path: 'guias/nueva', element: <NuevaGuia /> },
      { path: 'guias/:id', element: <NuevaGuia /> },
      { path: 'guias', element: <ListaGuias /> },
      { path: 'buscador', element: <Buscador /> },
      { path: 'estado-pago', element: <EstadoPago /> },
      { path: 'jornada', element: <Jornada /> },
      { path: 'admin', element: <Administracion /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ProveedorDialogo>
      <ProveedorAuth>
        <ProveedorCatalogos>
          <ProveedorGuias>
          <RouterProvider router={router} />
          </ProveedorGuias>
        </ProveedorCatalogos>
      </ProveedorAuth>
    </ProveedorDialogo>
  </React.StrictMode>,
);
